/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Basic details about an invitation (without accepting it)
 * @export
 * @interface GetInvitationDetails200Response
 */
export interface GetInvitationDetails200Response {
    /**
     * Email address the invitation was sent to
     * @type {string}
     * @memberof GetInvitationDetails200Response
     */
    email: string;
    /**
     * Name of the company the user is being invited to
     * @type {string}
     * @memberof GetInvitationDetails200Response
     */
    companyName: string;
}

/**
 * Check if a given object implements the GetInvitationDetails200Response interface.
 */
export function instanceOfGetInvitationDetails200Response(value: object): value is GetInvitationDetails200Response {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    return true;
}

export function GetInvitationDetails200ResponseFromJSON(json: any): GetInvitationDetails200Response {
    return GetInvitationDetails200ResponseFromJSONTyped(json, false);
}

export function GetInvitationDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvitationDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'companyName': json['companyName'],
    };
}

export function GetInvitationDetails200ResponseToJSON(json: any): GetInvitationDetails200Response {
    return GetInvitationDetails200ResponseToJSONTyped(json, false);
}

export function GetInvitationDetails200ResponseToJSONTyped(value?: GetInvitationDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'companyName': value['companyName'],
    };
}

